import React, { useEffect } from 'react';
import { Row } from 'reactstrap';

const Pagination = ({ data, currentPage, setCurrentPage, perPageData }) => {
  const handleClick = e => {
    setCurrentPage(e);
  };

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(data?.length / perPageData); i++) {
    pageNumbers.push(i);
  }
  const handleprevPage = () => {
    let prevPage = currentPage - 1;
    setCurrentPage(prevPage);
  };
  const handlenextPage = () => {
    let nextPage = currentPage + 1;
    setCurrentPage(nextPage);
  };

  useEffect(() => {
    if (pageNumbers.length && pageNumbers.length < currentPage) {
      setCurrentPage(pageNumbers.length);
    }
  }, [pageNumbers.length, currentPage, setCurrentPage]);

  const atFirst = currentPage <= 1;
  const atLast = currentPage >= pageNumbers.length;

  return (
    <React.Fragment>
      <Row className='g-0 justify-content-end mb-4'>
        <nav className='col-sm-auto' aria-label='Pagination'>
          <ul className='pagination-block pagination pagination-separated flex-wrap justify-content-center justify-content-sm-end mb-sm-0'>
            <li className={atFirst ? 'page-item disabled' : 'page-item'}>
              <button
                type='button'
                className='page-link'
                onClick={handleprevPage}
                disabled={atFirst}
              >
                Previous
              </button>
            </li>
            {pageNumbers.map(item => (
              <li key={item} className='page-item'>
                <button
                  type='button'
                  className={
                    currentPage === item ? 'page-link active' : 'page-link'
                  }
                  aria-label={`Page ${item}`}
                  aria-current={currentPage === item ? 'page' : undefined}
                  onClick={() => handleClick(item)}
                >
                  {item}
                </button>
              </li>
            ))}
            <li className={atLast ? 'page-item disabled' : 'page-item'}>
              <button
                type='button'
                className='page-link'
                onClick={handlenextPage}
                disabled={atLast}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </Row>
    </React.Fragment>
  );
};

export default Pagination;
